<div class="content">
  <img src="../assets/img/sad.svg" alt="">
  <p>Ops!... lo siento, no tengo la informacion que buscas</p>
</div>